import styled from 'styled-components';

export const SideBarV2Style = styled.div`
  width: 230px;
  height: 100vh;
  background-color: #111823;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  margin-bottom: 90px;
  padding-top: 58px;  
  padding-bottom: 90px;


  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;

  /* Desktop fixed sidebar */
  &.sidebarForPc {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  }

  /* Mobile sidebar (shown in drawer) */
  &.sidebarForMob {
    position: relative;
    height: auto;
  }

  @media (max-width: 768px) {
    &.sidebarForPc {
      display: none;
    }
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #b8b8b841; /* light grey */
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b8b8b841;
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #b8b8b841 transparent;

  .sidebar-container {
    padding: 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    overflow-y: auto;
  }

  /* Library Section */
  .library-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .library-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 4px 0;
  }

  .library-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }

  .library-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
  }

  .menu-items {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .menu-item {
    padding: 2px 6px;
    font-size: 13px;
    color: #a0a0b0;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
      color: #ffffff;

      svg {
        color: #ffffff;
      }
    }

    &.active {
      background-color: rgba(255, 255, 255, 0.1);
      color: #ffffff;
      font-weight: 500;

      svg {
        color: #ffffff;
      }
    }

    svg {
      flex-shrink: 0;
      color: #a0a0b0;
      transition: color 0.2s ease;
    }
  }

  .menu-item-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .unseen-campaign-badge {
    background-color: #007AFE;
    color: #ffffff;
    font-size: 10px;
    font-weight: 600;
    min-width: 18px;
    height: 18px;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    margin-left: auto;
    flex-shrink: 0;
    line-height: 1;
  }

  /* Section Headers */
  .section-header {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 0;
    position: relative;
  }

  .section-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    flex: 1;
  }

  /* Playlist Actions */
  .playlist-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
  }

  .action-icon {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    transition: opacity 0.2s ease;
    font-size: 14px;

    &:hover {
      opacity: 0.7;
    }

    svg {
      width: 1em;
      height: 1em;
    }
  }

  /* Playlists Section */
  .playlists-section {
    display: flex;
    flex-direction: column;
  }

  /* Search Input Container */
  .search-input-container {
    position: relative;
    width: 100%;
    height: 30px;
    margin-top: 4px;
    
  }

  .playlist-search-input {
    width: 100%;
    /* leave extra right padding to make room for the absolute positioned button */
    padding: 0px 44px 0px 12px;
    border: 1px solid #424242;
    border-radius: 6px;
    background-color: #242A34;
    color: #fff;
    font-size: 10px;
    outline: none;
    transition: all 0.2s ease;
    box-sizing: border-box;
    height: 30px;

    &:focus {
      border-color: #007AFE;
      box-shadow: 0 0 0 2px #007bfe22;
    }

    &::placeholder {
      color: #707070;
    }
  }

  .search-button {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    height: 20px;
    box-sizing: border-box;

    &:hover {
      background-color: #444;
    }

    .search-icon {
      width: 14px;
      height: 14px;
      color: #8c8c8c;
      display: block;
      line-height: 0;
    }
  }

  /* Playlist Items */
  .playlist-items {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: calc(-740px + 100vh);
    min-height: 140px;
    overflow-y: auto;
    margin-top: 8px;

    /* Thin light transparent scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(208, 208, 208, 0.3);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(208, 208, 208, 0.5);
    }

    /* Hide scrollbar buttons */
    &::-webkit-scrollbar-button {
      display: none;
    }

    /* Firefox scrollbar */
    scrollbar-width: thin;
    scrollbar-color: rgba(208, 208, 208, 0.3) transparent;
  }

  .playlist-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #a0a0b0;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;
    padding: 2px 6px;
    font-size: 13px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
      color: #ffffff;
    }

    &.active {
      background-color: rgba(255, 255, 255, 0.1);
      color: #ffffff;
      font-weight: 500;
    }
  }

  .playlist-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .playlist-count {
    font-size: 12px;
    color: #70707a;
    margin-left: 8px;
  }

  .search-loading,
  .no-results {
    padding: 10px;
    text-align: center;
    color: #8c8c8c;
    font-size: 12px;
  }

  .view-more-link { 
    padding: 4px 6px;
    font-size: 12px;
    color: #007AFE;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #007bfe22;
    }
  }

  .create-playlist-link {
    padding: 4px 6px;
    font-size: 12px;
    color: #007AFE;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #007bfe22;
    }
  }

  /* Loading Animation */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dashoffset: 31.4;
    }
    25% {
      stroke-dashoffset: 15.7;
    }
    50% {
      stroke-dashoffset: 0;
    }
    75% {
      stroke-dashoffset: -15.7;
    }
    100% {
      stroke-dashoffset: -31.4;
    }
  }

  /* Recently Scheduled Section */
  .recently-scheduled-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .recently-scheduled-items {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 8px;
  }

  .recently-scheduled-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0px 0px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }
  }

  .item-image {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
    background-color: #1a1a2e;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
    }
  }

  .item-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .item-title {
    font-size: 13px;
    color: #ffffff;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .item-artist {
    font-size: 12px;
    color: #70707a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .load-more-link { 
    padding: 4px 6px;
    font-size: 12px;
    color: #007AFE;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #007bfe22;
    }
  }

  /* Recently Scheduled Loading State */
  .recently-scheduled-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    gap: 8px;

    .loading-spinner {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #007AFE;
    }

    span {
      font-size: 12px;
      color: #8c8c8c;
    }
  }

  /* No Scheduled Songs State */
  .no-scheduled-songs {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    gap: 8px;

    p {
      font-size: 12px;
      color: #8c8c8c;
      margin: 0;
      text-align: center;
    }
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    width: 240px;

    .sidebar-container {
      padding: 16px 12px;
    }

    .library-title,
    .section-title {
      font-size: 14px;
    }

    .menu-item,
    .playlist-item {
      font-size: 13px;
      padding: 8px 10px;
    }
  }

  /* Slightly reduce font-sizes and paddings for small laptop screens <= 1300px */
  @media (max-width: 1300px) {
    .library-title,
    .section-title {
      font-size: 13px; /* down from 14px */
    }

    .menu-item,
    .playlist-item {
      font-size: 12px; /* down from 13px */
      /* restore original compact padding so items don't grow */
      padding: 2px 6px;
    }

    .playlist-name {
      font-size: 12px;
    }

    .playlist-count,
    .item-artist,
    .view-more-link,
    .create-playlist-link,
    .load-more-link {
      font-size: 11px; /* reduce small meta text */
    }

    .item-title {
      font-size: 12px; /* down from 13px */
    }

    .playlist-items {
      max-height: calc(-660px + 100vh); /* adjust slightly to reflect reduced spacing */
    }

    .menu-items {
      gap: 4px; /* reduce gap slightly */
    }

    .playlist-items {
      gap: 4px; /* reduce gap slightly */
    }

    /* Make recently scheduled items more compact */
    .recently-scheduled-item {
      gap: 8px; /* reduce from 12px */
      padding: 0; /* keep compact */
    }

    .item-image {
      width: 34px;
      height: 34px;
      border-radius: 5px;

      img {
        border-radius: 5px;
      }
    }

    .item-info {
      gap: 2px;
    }

    .item-title {
      font-size: 12px; /* slightly smaller */
    }

    .item-artist {
      font-size: 11px; /* slightly smaller */
    }

  }

  @media (max-width: 1336px) {
    .playlist-items {
      max-height: calc(-614px + 100vh);
    }
  }
`;
